import ReactNativeFile from "@repo/graphql/client/file";
import * as yup from "yup";

const fileSchema = yup
  .object({
    name: yup.string().required(),
    type: yup.string().required(),
    uri: yup.string().required(),
  })
  .transform((value: ReactNativeFile | null) => {
    if (
      value?.uri.startsWith("file://") ||
      value?.uri.startsWith("data:") ||
      value?.uri.startsWith("blob:")
    ) {
      return value;
    }
    return null;
  });

export default fileSchema;
